import InputField from "@/components/Common/forms/InputField";
import useRegistrationStore, {type TRegistrationState} from "@/store/registration";
import {kebabCase} from "lodash";
import {type FC, type HTMLInputTypeAttribute, type ReactNode} from "react";
import {useTranslation} from "react-i18next";

const RegistrationInputField: FC<{
  onChange?: (value: string) => void;
  storeKey: keyof TRegistrationState["errors"];
  icon?: ReactNode;
  type?: HTMLInputTypeAttribute;
  isLoading?: boolean;
  label?: string;
  value?: string | null;
  placeholder?: string;
  className?: string;
  labelClassName?: string;
  name?: string;
  disabled?: boolean;
  optional?: boolean;
}> = ({
  onChange,
  storeKey,
  icon = null,
  isLoading,
  label,
  placeholder,
  type = "text",
  value,
  className,
  labelClassName,
  name,
  disabled = false,
  optional,
}) => {
  const {t} = useTranslation("common");
  const errorMessage = useRegistrationStore(state => state.errors[storeKey]);
  const setValue = useRegistrationStore(state => state.setValue);
  const valueFromStore = useRegistrationStore(state => state[storeKey]);

  return (
    <InputField
      onChange={value => (onChange ? onChange(value) : setValue(storeKey, value))}
      className={className}
      icon={icon}
      isLoading={isLoading}
      label={label}
      labelClassName={labelClassName}
      placeholder={placeholder}
      type={type}
      value={value ?? valueFromStore}
      error={t(errorMessage as "First name is required")}
      name={name ?? storeKey}
      customFieldId={`registration-${kebabCase(storeKey)}-field`}
      dataTestId={`registration-${kebabCase(storeKey)}-field`}
      isDisabled={disabled}
      optional={optional}
    />
  );
};

export default RegistrationInputField;
